import { render } from "./UsersHospitals.vue?vue&type=template&id=f4315b56&scoped=true&lang=pug"
import script from "./UsersHospitals.vue?vue&type=script&lang=js"
export * from "./UsersHospitals.vue?vue&type=script&lang=js"

import "./UsersHospitals.vue?vue&type=style&index=0&id=f4315b56&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4315b56"]])

export default __exports__